/**
 * @file Automatically generated by barrelsby.
 */

export * from './admin-navbar.component';
